/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Data_Loss_AckInputs */



/**
* | output |
* | --- |
* | "I understand unsaved changes on the other device will be permanently lost." |
*
* @param {Offline_Data_Loss_AckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_data_loss_ack = /** @type {((inputs?: Offline_Data_Loss_AckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Data_Loss_AckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Je comprends que les modifications non sauvegardées sur l'autre appareil seront définitivement perdues.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entiendo que los cambios no guardados en el otro dispositivo se perderán de forma permanente.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entendo que as alterações não salvas no outro dispositivo serão perdidas permanentemente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confermo che le modifiche non salvate sull'altro dispositivo andranno definitivamente perse.")
	return /** @type {LocalizedString} */ ("I understand unsaved changes on the other device will be permanently lost.")
});